import { Laya3DRender } from "../../RenderObjs/Laya3DRender";
import { Light, LightType } from "./Light";
export class PointLightCom extends Light {
    get range() {
        return this._range;
    }
    set range(value) {
        this._range = value;
        this._dataModule.range = value;
    }
    constructor() {
        super();
        this._lightType = LightType.Point;
        this.range = 6.0;
    }
    _creatModuleData() {
        this._dataModule = Laya3DRender.Render3DModuleDataFactory.createPointLight();
    }
    _addToLightQueue() {
        this.owner.scene._pointLights.add(this);
    }
    _removeFromLightQueue() {
        this.owner.scene._pointLights.remove(this);
    }
    _cloneTo(dest) {
        super._cloneTo(dest);
        dest.range = this.range;
        dest._lightType = LightType.Point;
    }
}
